<template>
  <section>
    <keep-alive>
      <router-view v-if="isRouterAlive" :key="key"></router-view>
    </keep-alive>
  </section>
</template>
<script>
export default {
  name: "icenter",
  provide() {
    // 注册一个方法
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  watch:{},
  computed: {
    key() {
      // return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
      return this.$route.Path;
      // return this.$route.fullPath;
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
}
</script>
<style lang="less" scoped>
  
</style>